var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`page-container-${_vm.page.slug}`},[(_vm.dynamicComponent)?_c(_vm.dynamicComponent,_vm._g(_vm._b({tag:"component",on:{"hook:mounted":function($event){return _vm.$emit('mounted')}}},'component',{ ..._vm.$attrs, ..._vm.$props },false),_vm.$listeners),[_vm._t("default")],2):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }